function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.5
}, React.createElement("mask", {
  id: "path-1-inside-1"
}, React.createElement("path", {
  id: "path-1",
  d: "M820 410C820 636.437 636.437 820 410 820C183.563 820 0 636.437 0 410C0 183.563 183.563 0 410 0C636.437 0 820 183.563 820 410ZM123 410C123 568.506 251.494 697 410 697C568.506 697 697 568.506 697 410C697 251.494 568.506 123 410 123C251.494 123 123 251.494 123 410Z"
})), React.createElement("path", {
  id: "path-2",
  d: "M820 410C820 636.437 636.437 820 410 820C183.563 820 0 636.437 0 410C0 183.563 183.563 0 410 0C636.437 0 820 183.563 820 410ZM123 410C123 568.506 251.494 697 410 697C568.506 697 697 568.506 697 410C697 251.494 568.506 123 410 123C251.494 123 123 251.494 123 410Z",
  mask: "url(#path-1-inside-1)"
}));

var SvgBigCircle = function SvgBigCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 820,
    height: 820,
    viewBox: "0 0 820 820",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBigCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/big-circle.515215aa.svg";
export { ForwardRef as ReactComponent };